import React, { useId, useState } from 'react';

/**
 * Input con icono circular a la izquierda, label flotante y accion opcional a la
 * derecha (ojo, copiar, generar...). `rightAction` es un nodo completo (normalmente
 * un boton icono) para que cada pantalla decida su comportamiento.
 */
function Input({
  icon: Icon,
  label,
  rightAction,
  error,
  className = '',
  containerProps = {},
  placeholder,
  ...inputProps
}) {
  const id = useId();
  const [focused, setFocused] = useState(false);
  const hasValue = inputProps.value !== undefined && inputProps.value !== '' && inputProps.value !== null;
  const hasLabel = Boolean(label);

  return (
    <div
      className={`sgc-input ${focused ? 'sgc-input--focused' : ''} ${error ? 'sgc-input--error' : ''} ${className}`}
      {...containerProps}
    >
      {Icon && (
        <span className="sgc-input__icon">
          <Icon width={18} height={18} aria-hidden="true" />
        </span>
      )}
      <div className="sgc-input__field">
        {/*
          El input va ANTES que el label a proposito: el CSS eleva el label con
          un selector de hermanos (input ~ label) apoyado en :placeholder-shown
          y :-webkit-autofill, para que funcione tambien con el autorelleno del
          navegador, que no dispara onChange y por tanto no actualiza `hasValue`.
          Las clases --focused/--float en JS se mantienen como refuerzo, no son
          ya la unica via.
        */}
        <input
          id={id}
          className={`sgc-input__control ${hasLabel ? 'sgc-input__control--labeled' : ''}`}
          placeholder={hasLabel ? ' ' : placeholder}
          onFocus={(e) => { setFocused(true); inputProps.onFocus?.(e); }}
          onBlur={(e) => { setFocused(false); inputProps.onBlur?.(e); }}
          {...inputProps}
        />
        {label && (
          <label
            htmlFor={id}
            className={`sgc-input__label ${(focused || hasValue) ? 'sgc-input__label--float' : ''}`}
          >
            {label}
          </label>
        )}
      </div>
      {rightAction && <div className="sgc-input__action">{rightAction}</div>}
      {error && <p className="sgc-input__error">{error}</p>}
    </div>
  );
}

export default Input;
